import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from 'vue'

export type LetterExampleSentenceItem = {
  name: string
  sentences: string
  type?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterExampleSentenceDialog',
  props: {
    value: { type: Boolean },
    name: null,
    items: null
  },
  emits: ["input", "select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'select', sentences: string): void
}), expose: any, slots: any, attrs: any }) {





/** margin-block:auto 縦中央だと overflow コンテナが下端寄りに開くことがあるので上寄せ＋scroll リセット */
function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.letter-example-sentence-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onSelect(sentences: string) {
  emit('select', sentences.replace(/<br>/gi, '\n'))
  emit('input', false)
}

return { __sfc: true,emit, onOpened, onSelect }
}

})